<template>
  <!-- 图片上传 -->
  <el-upload
    ref="upload"
    :class="{hide:hideUpload}"
    accept=".jpg,.png"
    :action="uploadUrl"
    list-type="picture-card"
    :auto-upload="false"
    :multiple="true"
    :show-file-list="true"
    :limit="maxNum"
    :file-list="listObj"
    :on-remove="handleRemove"
    :on-success="handleSuccess"
    :on-error="handleError"
    :on-exceed="handleExceed"
    :on-change="imgChange"
    :disabled="disabled"
  >
    <i class="el-icon-plus" />
    <div slot="tip" class="el-upload__tip" style="font-size:10px;margin-top:5px;line-height: 16px;">只能上传jpg/png文件，且不超过1MB</div>
  </el-upload>
</template>

<script>

export default {
  name: 'UploadImage',
  props: {
    maxNum: { // 最大上传图片数量
      type: Number,
      default: 10
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listObj: [], // 接收上传的图片信息
      hideUpload: false,
      uploadUrl: 'https://nps-bdc.yingxiong.com/testGatewayFile/api/file/fileUpload'
    }
  },

  methods: {

    // 上传失败
    handleError(err, file, fileList) {
      this.$message({
        message: '上传失败',
        type: 'error'
      })
      this.listObj = []
      this.hideUpload = this.listObj.length >= this.maxNum
      this.$emit('uploadBack', '')
      console.log(err)
    },

    // 上传成功
    handleSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      if (res.code == 1) {
        this.listObj = fileList
      } else {
        this.listObj = []
      }
      this.hideUpload = this.listObj.length >= this.maxNum
      this.$emit('uploadBack', res.data || '')
    },

    // 删除上传的图片
    handleRemove(file, fileList) {
      console.log('删除图片fileList==========', fileList)
      this.listObj = fileList
      this.hideUpload = this.listObj.length >= this.maxNum
      this.$emit('uploadBack', '')
    },

    // 监听上传
    imgChange(file, fileList) {
      console.log(3333)
      const typeCheck = file.name.endsWith('jpg') || file.name.endsWith('png')
      const isLt1M = file.size / 1024 / 1024 <= 1

      if (!typeCheck) {
        this.$message.warning('只能上传jpg/png文件!')
      }
      if (!isLt1M) {
        this.$message.warning('图片大小不能超过1MB')
      }
      if (typeCheck && isLt1M) {
        this.hideUpload = this.listObj.length >= this.maxNum
        this.$refs.upload.submit()
      } else {
        this.listObj = []
      }
    },

    // 超出上传数量限制
    handleExceed() {
      this.$message.warning('最多只能上传' + this.maxNum + '张图片')
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
  }

  .hide {
    height: 130px;
    position: relative;
    .el-upload__tip{
      position:absolute;
      top: 100px;
    }
    ::v-deep .el-upload--picture-card {
      display: none;
    }
  }

</style>
